import { motion } from 'framer-motion';

const RING_GOLD = '#C8A830';
const SAURON_ORANGE = '#FF5500';
const SAURON_RED = '#CC2200';

function getEmberColor(i: number): string {
  if (i % 3 === 0) return SAURON_ORANGE;
  if (i % 5 === 0) return RING_GOLD;
  return `${SAURON_RED}80`;
}

export function LordOfTheRingsBg() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' style={{ zIndex: 0 }}>
      <div className='absolute inset-0' style={{ background: 'radial-gradient(ellipse 100% 80% at 50% 20%, #1a0a0208, transparent 70%)' }} />
      <div className='absolute inset-0' style={{ background: `radial-gradient(ellipse 70% 50% at 80% 70%, ${RING_GOLD}06, transparent 60%)` }} />

      <motion.svg className='absolute' width='120' height='120' viewBox='0 0 120 120' fill='none' style={{ left: '3%', top: '20%', filter: `drop-shadow(0 0 15px ${RING_GOLD}40) drop-shadow(0 0 35px ${RING_GOLD}20)` }} animate={{ rotate: [0, 360] }} transition={{ duration: 30, repeat: Infinity, ease: 'linear' as const }}>
        <circle cx='60' cy='60' r='50' stroke={RING_GOLD} strokeWidth='8' fill='none' opacity='0.2' />
        <circle cx='60' cy='60' r='42' stroke={RING_GOLD} strokeWidth='1.5' fill='none' opacity='0.12' />
        {Array.from({ length: 36 }).map((_, i) => {
          const angle = (i / 36) * Math.PI * 2;
          const r = 50;
          const x = 60 + Math.cos(angle) * r;
          const y = 60 + Math.sin(angle) * r;
          return <motion.circle key={`insc-${i}`} cx={x} cy={y} r={i % 3 === 0 ? 2.5 : 1.5} fill={RING_GOLD} opacity='0.3' animate={{ opacity: [0.15, 0.6, 0.15] }} transition={{ duration: 1.5, delay: i * 0.12, repeat: Infinity, ease: 'easeInOut' as const }} />;
        })}
        {Array.from({ length: 8 }).map((_, i) => {
          const startAngle = (i / 8) * 360;
          const r = 50;
          const x1 = 60 + Math.cos((startAngle * Math.PI) / 180) * r;
          const y1 = 60 + Math.sin((startAngle * Math.PI) / 180) * r;
          const x2 = 60 + Math.cos(((startAngle + 30) * Math.PI) / 180) * r;
          const y2 = 60 + Math.sin(((startAngle + 30) * Math.PI) / 180) * r;
          return <motion.path key={`arc-${i}`} d={`M${x1} ${y1} A50 50 0 0 1 ${x2} ${y2}`} stroke={RING_GOLD} strokeWidth='1.5' fill='none' animate={{ opacity: [0.1, 0.45, 0.1] }} transition={{ duration: 2, delay: i * 0.3, repeat: Infinity, ease: 'easeInOut' as const }} />;
        })}
        <motion.circle cx='60' cy='60' r='50' stroke={RING_GOLD} strokeWidth='2.5' fill='none' animate={{ opacity: [0.1, 0.35, 0.1], r: [50, 52, 50] }} transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' as const }} />
      </motion.svg>

      <div className='absolute' style={{ right: '3%', top: '35%', width: 90, height: 55, opacity: 0.25 }}>
        <svg width='90' height='55' viewBox='0 0 90 55' fill='none' style={{ filter: `drop-shadow(0 0 12px ${SAURON_ORANGE}30) drop-shadow(0 0 25px ${SAURON_RED}15)` }}>
          <path d='M5 27.5 Q20 2, 45 2 Q70 2, 85 27.5 Q70 53, 45 53 Q20 53, 5 27.5Z' stroke={SAURON_ORANGE} strokeWidth='1.5' fill={`${SAURON_RED}08`} opacity='0.5' />
          <path d='M15 27.5 Q28 10, 45 10 Q62 10, 75 27.5 Q62 45, 45 45 Q28 45, 15 27.5Z' stroke={SAURON_ORANGE} strokeWidth='0.8' fill={`${SAURON_ORANGE}06`} opacity='0.35' />
          <ellipse cx='45' cy='27.5' rx='4' ry='16' fill={SAURON_ORANGE} opacity='0.3' />
          <ellipse cx='45' cy='27.5' rx='2' ry='12' fill={SAURON_RED} opacity='0.4' />
          <ellipse cx='45' cy='27.5' rx='1' ry='8' fill='#FF2200' opacity='0.5' />
        </svg>
        <motion.div className='absolute rounded-full' style={{ width: 60, height: 60, left: 15, top: -2, background: `radial-gradient(circle, ${SAURON_ORANGE}15, transparent 70%)`, filter: 'blur(15px)' }} animate={{ scale: [1, 1.3, 1], opacity: [0.3, 0.6, 0.3] }} transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' as const }} />
      </div>

      {Array.from({ length: 25 }).map((_, i) => (
        <motion.div key={`ember-${i}`} className='absolute rounded-full' style={{ width: i % 4 === 0 ? 3 : 1.5, height: i % 4 === 0 ? 3 : 1.5, left: `${(i * 13.7) % 100}%`, bottom: `${(i * 7.3) % 30}%`, background: getEmberColor(i) }} animate={{ y: [0, -80 - (i % 5) * 30], opacity: [0, 0.25, 0], x: [0, i % 2 === 0 ? 10 : -10] }} transition={{ duration: 4 + (i % 5) * 1.5, delay: (i % 10) * 0.8, repeat: Infinity, ease: 'easeOut' as const }} />
      ))}

      {['', '', '', '', '', ''].map((_, i) => (
        <motion.div key={`tengwar-${i}`} className='absolute select-none' style={{ left: i % 2 === 0 ? `${2 + i}%` : `${92 + (i % 3)}%`, top: `${12 + i * 14}%`, fontSize: 14, color: RING_GOLD, textShadow: `0 0 8px ${RING_GOLD}40`, fontFamily: 'serif', opacity: 0 }} animate={{ opacity: [0, 0.12, 0.08, 0.12, 0] }} transition={{ duration: 6, delay: i * 1.8, repeat: Infinity, ease: 'easeInOut' as const }}>
          {['\u2295', '\u25C8', '\u27E1', '\u25C7', '\u229B', '\u27D0'][i]}
        </motion.div>
      ))}
    </div>
  );
}
